import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ActivacionCargueFiviI } from 'src/app/modelos/ActivacionCargueFivi';
import { EstadoInfoFiviI } from 'src/app/modelos/EstadoInformacionFivi';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { PeriodoReporteFiviI } from 'src/app/modelos/PeriodoReporteFivi';
import { VistaAdminInfoI } from 'src/app/modelos/VistaAdminInfo';
import { VistaHistoricoActivacionCargueFiviI } from 'src/app/modelos/VistaHistorialActivacionCargueFivi';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { AnalisisService } from '../../../servicios/analisis/analisis.service';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-activarcarguefivi',
  templateUrl: './activarcarguefivi.component.html',
  styleUrls: ['./activarcarguefivi.component.css']
})
export class ActivarcarguefiviComponent implements OnDestroy,OnInit {

  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  aniosVigen: Number[];
  PeriodoSeleccionado : PeriodoReporteFiviI = new PeriodoReporteFiviI;
  anioConsulta : Number = 0;
  consucutivoConsulta : Number = 0;

  PeriodosConsultar : PeriodoReporteFiviI[];
  ListaEstadosFuentes : VistaAdminInfoI[];
  IdPeriodoConsulta : BigInteger;
  PeriodoActivo : PeriodoReporteFiviI = new PeriodoReporteFiviI;
  Fuente : fuenteI = new fuenteI;
  EstadoInformacionSelect : EstadoInfoFiviI = new EstadoInfoFiviI;
  CambioEstadoCargue : ActivacionCargueFiviI = new ActivacionCargueFiviI;
  ObservacionInactivar : String;
  PeriodoModales : String;
  BtnInactivar : Boolean;
  ActivarCargueModalInactivar : Boolean;
  ObservacionActivar : String;
  BtnActivar : Boolean;
  HistorialActivacionCargue : VistaHistoricoActivacionCargueFiviI[];
  page : number;

  @ViewChild('openmodalinactivarcargue') openmodalinactivarcargue: ElementRef;
  @ViewChild('closemodalinactivarcargue') closemodalinactivarcargue: ElementRef;
  @ViewChild('openmodalactivarcargue') openmodalactivarcargue: ElementRef;
  @ViewChild('closemodalactivarcargue') closemodalactivarcargue: ElementRef;
  @ViewChild('openmodalverhistorial') openmodalverhistorial: ElementRef;
  @ViewChild('closemodalverhistorial') closemodalverhistorial: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private analisisService:AnalisisService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ estados"
        }
    };
    this.api.listaPeriodosCalendarioFivi().subscribe(Lista1=>{
      this.PeriodosConsultar = Lista1;
    });
    this.analisisService.consultarPeriodoActivoFIVI().subscribe(PActivo=>{
      this.anioConsulta = Number(PActivo.anio);
      this.consucutivoConsulta = Number(PActivo.consecutivoPeriodo);
      this.PeriodoActivo = PActivo;
      this.IdPeriodoConsulta = PActivo.id;
      this.api.ListaEstadoInformacionFiviPorPeriodo(PActivo.id).subscribe(Lista=>{
        this.ListaEstadosFuentes = Lista;
        this.dtTrigger.next();
      });
    });
    this.analisisService.getListaAniosVigenciaFivi().subscribe(respuesta0=>{
      this.aniosVigen = respuesta0;
    });
    this.ActivarCargueModalInactivar = false;
    this.BtnInactivar = false;
    //this.BtnActivar = false;
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  RegresarAdminFivi(){
    this.router.navigate(['admininfofivi']);
  }

  peridoPorAnioMes(){
    this.analisisService.periodoFiviPorAnioMes(this.anioConsulta,this.consucutivoConsulta).subscribe(respuesta2=>{
      this.PeriodoSeleccionado = respuesta2;
      this.IdPeriodoConsulta = respuesta2.id;
      this.CosultarListaEstados(respuesta2.id);
    });
  }

  CosultarListaEstados(IdPeriodo){
    this.IdPeriodoConsulta = IdPeriodo;
    this.api.PeriodoFiviPorId(IdPeriodo).subscribe(Result2_2=>{
      this.PeriodoActivo = Result2_2;
    });
    this.api.ListaEstadoInformacionFiviPorPeriodo(IdPeriodo).subscribe(result2=>{
      this.ListaEstadosFuentes = result2;
      this.reinicializarDataTable();
    });
  }

  reinicializarDataTable(): void {
    this.dtElement.dtInstance.then((dtInstance: any) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  VerificarCondiciones(IdEstadoInfor){
    let FechaHoy = new Date()
    let HoyDia = FechaHoy.getDate();
    let HoyMes = FechaHoy.getMonth()+1;
    let HoyAnio = FechaHoy.getFullYear();
    let VerificarRecoleccion = this.PeriodoActivo.fechaFinProcesamiento.split("/");
    if ((HoyAnio == +VerificarRecoleccion[2]) && (HoyMes <= +VerificarRecoleccion[1]) && (HoyDia <= +VerificarRecoleccion[0])){
      this.api.ConsultarEstadoInfoFiviPorId(IdEstadoInfor).subscribe(Result3=>{
        if ((Result3.estadocargue=="Activo") && (Result3.estado=="Aprobado") && (Result3.novedadUsu!="14. Certificado de No Movimiento")){
          this.IniciarInactivacion(Result3.id);
        }else if ((Result3.estadocargue=="Activo") && (Result3.estado=="Cargado") && (Result3.novedadUsu!="14. Certificado de No Movimiento")){
          this.IniciarInactivacion(Result3.id);
        }else if ((Result3.estadocargue=="Activo") && (Result3.estado=="Pendiente") && (Result3.novedadUsu=="0. Pendiente")){
          this.toastr.warning('Solo se Inactiva reportes que tengan Estado Fuente: Cargado o Aprobado.','Advertencia!');
        }else if ((Result3.estadocargue=="Activo") && (Result3.estado=="En Proceso") && (Result3.novedadUsu=="0. Pendiente")){
          this.toastr.warning('Solo se Inactiva reportes que tengan Estado Fuente: Cargado o Aprobado.','Advertencia!');
        }else if ((Result3.estadocargue=="Activo") && (Result3.estado=="En cargue") && (Result3.novedadUsu=="0. Pendiente")){
          this.toastr.warning('Solo se Inactiva reportes que tengan Estado Fuente: Cargado o Aprobado.','Advertencia!');
        }else if ((Result3.estadocargue=="Activo") && (Result3.estado=="Aprobado") && (Result3.novedadUsu=="14. Certificado de No Movimiento")){
          this.IniciarActivacion(Result3.id);
        }else if ((Result3.estadocargue=="Activo") && (Result3.estado=="Cargado") && (Result3.novedadUsu=="14. Certificado de No Movimiento")){
          this.IniciarActivacion(Result3.id);
        }else if ((Result3.estadocargue=="Inactivo") && (Result3.estado=="Pendiente") ){
          this.IniciarActivacion(Result3.id);
        }else{
          this.toastr.warning('La fuente no ha reportado información en el periodo.','Advertencia!');
        }
      });
    }else{
      this.toastr.warning('Cargue fuera del periodo en referencia.','Advertencia!');
    }
  }

  IniciarInactivacion(IdEstadoInfor){
    this.openmodalinactivarcargue.nativeElement.click();
    this.ObservacionInactivar = "";
    this.CambioEstadoCargue.errorVD = false;
    this.CambioEstadoCargue.errorNC = false;
    this.api.ConsultarEstadoInfoFiviPorId(IdEstadoInfor).subscribe(Result3=>{
      this.EstadoInformacionSelect = Result3;
      this.api.PeriodoFiviPorId(Result3.idPeriodo.id).subscribe(Result4=>{
        this.PeriodoModales = Result4.anio+" - "+Result4.consecutivoPeriodo;
      });
      this.api.getFuenteById(Result3.idFuente.id).subscribe(Result5=>{
        this.Fuente = Result5;
      });
    });
  }

  InactivarCargue(){
    this.BtnInactivar = true;
    this.CambioEstadoCargue.idFte = this.EstadoInformacionSelect.idFuente.id;
    this.CambioEstadoCargue.idEstinf = this.EstadoInformacionSelect.id;
    this.CambioEstadoCargue.idPeriodo = this.EstadoInformacionSelect.idPeriodo.id;
    this.CambioEstadoCargue.usuario = localStorage.getItem('usuario');
    this.CambioEstadoCargue.observacion = this.ObservacionInactivar;
    if(this.ObservacionInactivar.length == 0 || this.ObservacionInactivar.length == null){
      this.toastr.warning('Debe ingresar observación.','Advertencia!');
      this.BtnInactivar = false;
    } else if(this.ObservacionInactivar.length < 20){
      this.toastr.warning('Observación debe tener mínimo 20 caracteres.','Advertencia!');
      this.BtnInactivar = false;
    } else if(this.ObservacionInactivar.length > 500){
      this.toastr.warning('Observación debe tener máximo 500 caracteres.','Advertencia!');
      this.BtnInactivar = false;
    } else if(!this.CambioEstadoCargue.errorVD && !this.CambioEstadoCargue.errorNC){
      this.toastr.warning('Debe seleccionar al menos una variable que presente error.','Advertencia!');
      this.BtnInactivar = false;
    } else {
      this.ActivarCargueModalInactivar = true;
      this.api.InactivarCargueFivi(this.CambioEstadoCargue).subscribe(Result6=>{
        if(Result6){
          this.toastr.success('Se inactivo el cargue satisfactoriamente.','OK!');
          this.CosultarListaEstados(this.IdPeriodoConsulta);
        }
      });
    }
  }

  ActivarCargueDesdeInactivar(){
    this.CambioEstadoCargue.idFte = this.EstadoInformacionSelect.idFuente.id;
    this.CambioEstadoCargue.idEstinf = this.EstadoInformacionSelect.id;
    this.CambioEstadoCargue.idPeriodo = this.EstadoInformacionSelect.idPeriodo.id;
    this.CambioEstadoCargue.usuario = localStorage.getItem('usuario');
    this.CambioEstadoCargue.tipo = "Activar";
    this.CambioEstadoCargue.observacion = "Se activa cargue por inactivación en el mismo periodo.";
    this.CambioEstadoCargue.errorVD = false;
    this.CambioEstadoCargue.errorNC = false;
    this.api.ActivarCargueDesdeModalInactivarFivi(this.CambioEstadoCargue).subscribe(Result7=>{
      if(Result7){
        this.toastr.success('Se activo el cargue a la fuente correctamente.','OK!');
        this.BtnInactivar = false;
        this.CosultarListaEstados(this.IdPeriodoConsulta);
        this.closemodalinactivarcargue.nativeElement.click();
      }
    });
  }

  IniciarActivacion(IdEstadoInfor){
    this.openmodalactivarcargue.nativeElement.click();
    this.ObservacionActivar = "";
    this.api.ConsultarEstadoInfoFiviPorId(IdEstadoInfor).subscribe(Result8=>{
      this.EstadoInformacionSelect = Result8;
      this.api.PeriodoFiviPorId(Result8.idPeriodo.id).subscribe(Result9=>{
        this.PeriodoModales = Result9.anio+" - "+Result9.consecutivoPeriodo;
      });
      this.api.getFuenteById(Result8.idFuente.id).subscribe(Result10=>{
        this.Fuente = Result10;
      });
    });
  }

  ActivarCargue(){
    this.BtnActivar = true;
    this.CambioEstadoCargue.idFte = this.EstadoInformacionSelect.idFuente.id;
    this.CambioEstadoCargue.idEstinf = this.EstadoInformacionSelect.id;
    this.CambioEstadoCargue.idPeriodo = this.EstadoInformacionSelect.idPeriodo.id;
    this.CambioEstadoCargue.usuario = localStorage.getItem('usuario');
    this.CambioEstadoCargue.tipo = "Activar";
    this.CambioEstadoCargue.observacion = this.ObservacionActivar;
    this.CambioEstadoCargue.errorVD = false;
    this.CambioEstadoCargue.errorNC = false;

    if(this.ObservacionActivar.length == 0 || this.ObservacionActivar.length == null){
      this.toastr.warning('Debe ingresar observación.','Advertencia!');
      this.BtnActivar = false;
    }else if(this.ObservacionActivar.length < 20){
      this.toastr.warning('Observación debe tener mínimo 20 caracteres.','Advertencia!');
      this.BtnActivar = false;
    }else if(this.ObservacionActivar.length > 500){
      this.toastr.warning('Observación debe tener máximo 500 caracteres.','Advertencia!');
      this.BtnActivar = false;
    }else{
      this.api.ActivarCargueFivi(this.CambioEstadoCargue).subscribe(Result11=>{
        if(Result11){
          this.toastr.success('Se activo el cargue a la fuente correctamente.','OK!');
          this.BtnActivar = false;
          this.CosultarListaEstados(this.IdPeriodoConsulta);
          this.closemodalactivarcargue.nativeElement.click();
        }
      });
    }
  }

  VerHistorial(IdEstadoInfor){
    this.openmodalverhistorial.nativeElement.click();
    this.api.ConsultarEstadoInfoFiviPorId(IdEstadoInfor).subscribe(Result12=>{
      this.EstadoInformacionSelect = Result12;
      this.api.PeriodoFiviPorId(Result12.idPeriodo.id).subscribe(Result13=>{
        this.PeriodoModales = Result13.anio+" - "+Result13.consecutivoPeriodo;
      });
      this.api.getFuenteById(Result12.idFuente.id).subscribe(Result14=>{
        this.Fuente = Result14;
      });
      this.api.HistorialActivacionCargueFivi(Result12.id).subscribe(Result15=>{
        this.HistorialActivacionCargue = Result15;
      });
    });
  }




}
